import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Loader2 } from 'lucide-react';
import { adminAPI } from '../../services/api';
import { formatPrice } from '../../utils/helpers';
import { TxnTable } from './TxnTable';

export const WalletDetailDialog = ({ userId, onClose }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!userId) return;
    setData(null);
    adminAPI.getWalletDetail(userId).then(setData).catch(() => setData({ error: true }));
  }, [userId]);

  const u = data?.user;
  return (
    <Dialog open={!!userId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-gray-800 border-gray-700 text-white max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="wallet-detail-dialog">
        <DialogHeader>
          <DialogTitle>{u ? `${u.name || 'Usuario'} · ${u.email || ''}` : 'Detalle de billetera'}</DialogTitle>
        </DialogHeader>
        {!data ? (
          <div className="flex justify-center p-8"><Loader2 className="w-6 h-6 animate-spin text-gray-400" /></div>
        ) : data.error ? (
          <p className="text-red-400 p-4">No se pudo cargar el detalle</p>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div className="bg-gray-900/60 rounded-lg p-3">
                <p className="text-xs text-gray-400">Disponible</p>
                <p className="text-xl font-bold font-mono text-green-400" data-testid="wallet-detail-balance">{formatPrice(u.wallet_balance || 0)}</p>
              </div>
              <div className="bg-gray-900/60 rounded-lg p-3">
                <p className="text-xs text-gray-400">Saldo en transito</p>
                <p className="text-xl font-bold font-mono text-purple-400" data-testid="wallet-detail-in-transit">{formatPrice(u.balance_in_transit || 0)}</p>
              </div>
            </div>
            <TxnTable txns={data.transactions} testid="wallet-detail-txns" />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
